<template>
  <ul class="news-list" v-lazy-container="{ selector: 'img' }">
    <li class="list-item" v-for="item in list" :key="item.title" @click="handleClick(item)">
      <div class="item-content">
        <div class="item-title">{{item.title}}</div>
        <div class="item-info">{{item.posted_at}}</div>
      </div>
      <div class="item-img">
        <img :data-src="item.cover" :alt="item.title" >
      </div>
    </li>
  </ul>
</template>
<script>
  export default{
    name: "newslist",
    props: ['cid', 'list'],
    created(){
      console.log(this.cid)
    },
    methods: {
      handleClick(item){
        window.open(item.url)
      }
    }
  }
</script>
<style>
  .list-item{
    min-height: 3.2rem;
    list-style: none;
    padding: .8rem .7rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
  }
  .list-item::after{
    content: "";
    display: block;
    right: .7rem;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    position: absolute;
    left: .7rem;
    bottom: 0;
    transform: scaleY(0.5);
  }
  .list-item:last-child::after{
    display: none;
  }
  .item-content{
    flex: 1;
    font-size: .8rem;
    color: #0E141D;
  }
  .item-title{
    /* height: 2.1rem; */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    /* max-height: 2.1rem; */
  }
  .item-info{
    margin-top: .3rem;
    color: #868B95;
    font-size: .6rem;
  }
  .item-img{
    margin-left: .3rem;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: .2rem;
    overflow: hidden;   
  }
  .item-img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>